import React from 'react'
import successIcon from '../../assets/images/Successfull.png'

function PaymentSuccessfull() {
  return (
      <div className="Payment__Card">
          <div>
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                  <img src={successIcon} />
              </div>
              <p className="mt-3 mb-0" style={{ color: '#5e938d', fontSize: '18px', fontWeight: '600', textAlign:'center' }}>
                  Thank You!!!
              </p>
              <p className="mt-1" style={{ color: '#5e938d', fontSize: '18px', fontWeight: '600' }}>
                  Payment Successfull
              </p>
          </div>
      </div>
  );
}

export default PaymentSuccessfull